export default __webpack_public_path__ + "static/media/2450_2456.44e90128.jpg";